import { Link } from "react-router-dom";
import React from "react";
import { MdOutlineLaptopChromebook } from "react-icons/md";
import { FaDatabase, FaAward, FaHandHoldingDollar } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import { LuRefreshCw, LuScanFace } from "react-icons/lu";
import { LuUserRoundCheck } from "react-icons/lu";
import { BiTask } from "react-icons/bi";
import { TbUserPin } from "react-icons/tb";
import { MdMobileScreenShare } from "react-icons/md";
import {
  MdCircleNotifications,
  MdOutlineReceiptLong,
  MdOutlineAccessTime,
} from "react-icons/md";
import { SiGoogleforms } from "react-icons/si";
import { Navigation, Autoplay } from "swiper/modules";
import { MdCampaign } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { GiTakeMyMoney } from "react-icons/gi";
import { Helmet } from "react-helmet-async";

const features = [
  {
    title: "Payroll Management",
    desc: "Process salaries, generate payslips, manage deductions, and automate monthly payroll operations with full statutory compliance",
    icon: <FaDatabase size={28} color="#10324F" aria-hidden="true" />,
    link: "/payroll-management",
  },
  {
    title: "Attendance Management",
    desc: "Track employee attendance, working hours, late marks, and daily attendance records accurately across all teams",
    icon: <SlCalender size={28} color="#10324F" aria-hidden="true" />,
    link: "/attendance-management",
  },
  {
    title: "Shift Management",
    desc: "Create shifts, assign schedules, and manage workforce availability with better visibility and shift-based attendance rules",
    icon: <LuRefreshCw size={28} color="#10324F" aria-hidden="true" />,
    link: "/shift-management",
  },
  {
    title: "Leave Management",
    desc: "Handle leave requests, approvals, balances, and employee leave records from one centralised HR dashboard",
    icon: <LuUserRoundCheck size={28} color="#10324F" aria-hidden="true" />,
    link: "/leave-management",
  },
  {
    title: "Task Management",
    desc: "Assign tasks, track deadlines, monitor completion progress, and improve individual and team accountability",
    icon: <BiTask size={30} color="#10324F" aria-hidden="true" />,
    link: "/task-management",
  },
  {
    title: "Geo-Location Attendance",
    desc: "Enable location-based attendance tracking for field staff, remote employees, and multi-site workforce operations",
    icon: <TbUserPin size={28} color="#10324F" aria-hidden="true" />,
    link: "/geo-location-attendance",
  },
  {
    title: "Selfie-Based Attendance",
    desc: "Verify employee attendance with selfie check-ins eliminating proxy attendance and improving HR record accuracy",
    icon: <MdMobileScreenShare size={28} color="#10324F" aria-hidden="true" />,
    link: "/selfie-based-attendance",
  },
  {
    title: "Reminder Management",
    desc: "Manage employee reminders, follow-ups, approvals, and recurring business activities efficiently from one place",
    icon: (
      <MdCircleNotifications size={28} color="#10324F" aria-hidden="true" />
    ),
    link: "/reminder-management",
  },
  {
    title: "Tax & Forms Management",
    desc: "Organise payroll compliance, statutory records, employee forms, and all tax-related documentation in one place",
    icon: <SiGoogleforms size={28} color="#10324F" aria-hidden="true" />,
    link: "/tax-form-management",
  },
  {
    title: "Face Recognition Attendance",
    desc: "Mark employee attendance with AI-powered face recognition, selfie verification and GPS verification",
    icon: <LuScanFace size={28} color="#10324F" aria-hidden="true" />,
    link: "/face-recognition-attendance",
    isNew: true,
  },
  {
    title: "Company Announcements",
    desc: "Share company news, policy updates, holiday notices, events, and important announcements with all employees instantly",
    icon: <MdCampaign size={28} color="#10324F" aria-hidden="true" />,
    link: "/company-announcements",
  },
  {
    title: "Profile Settings",
    desc: "Manage company profile, branding, security preferences, user accounts, and application settings from one place",
    icon: <IoSettingsOutline size={28} color="#10324F" aria-hidden="true" />,
    link: "/profile-settings",
  },
  {
    title: "Employee Bonus Management",
    desc: "Reward employees with performance bonuses, festival bonuses, special incentives, and track bonus payment history",
    icon: <FaAward size={28} color="#10324F" aria-hidden="true" />,
    link: "/employee-bonus",
    isNew: true,
  },
  {
    title: "Expense Management",
    desc: "Record employee expenses, approve reimbursement requests, monitor spending, and maintain accurate expense reports",
    icon: <MdOutlineReceiptLong size={28} color="#10324F" aria-hidden="true" />,
    link: "/expense-management",
    isNew: true,
  },
  {
    title: "Incentive Management",
    desc: "Create employee incentive plans, reward achievements, monitor payouts, and improve workforce motivation",
    icon: <GiTakeMyMoney size={28} color="#10324F" aria-hidden="true" />,
    link: "/incentive-management",
    isNew: true,
  },
  {
    title: "Overtime Management",
    desc: "Track overtime hours, approve extra work, calculate overtime pay, and simplify payroll processing",
    icon: <MdOutlineAccessTime size={28} color="#10324F" aria-hidden="true" />,
    link: "/overtime-management",
    isNew: true,
  },
  {
    title: "Loan & Advance Salary",
    desc: "Manage employee loan requests, advance salary applications, EMI schedules, repayments, and approval workflows",
    icon: <FaHandHoldingDollar size={28} color="#10324F" aria-hidden="true" />,
    link: "/loan-advance-management",
    isNew: true,
  },
];

export default function AllFeaturesPage() {
  return (
    <>
      <Helmet>
        <title>
          Waggex HRMS Features | Payroll & Attendance Software for HRs
        </title>
        <meta
          name="description"
          content="Explore Waggex HRMS features for payroll, attendance, employee management, compliance, FaceLens, live location, and more for businesses in India."
        />
        <meta
          name="keywords"
          content="HRMS software features, HRMS features, payroll software features, HR software features, payroll management features, employee management software, HRMS software, payroll software"
        />
        <link rel="canonical" href="https://www.waggex.com/all-features" />
        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        /> */}
      </Helmet>
      <section
        id="OurFeature"
        className="relative overflow-hidden py-10 px-6 bg-[#d3e0eb]"
      >
        {/* Blur dots */}

        <div className="max-w-6xl mx-auto mb-8">
          {/* Section header */}
          <div className="text-center mb-14">
            <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold leading-snug uppercase mb-4">
              Smarter Tools for Payroll,
              <br /> Attendance & Workforce Management
            </h2>

            <p className="section-desc">
              Everything from attendance tracking and payroll processing to
              compliance management organized in one powerful HRMS solution
            </p>
          </div>

          {/* Cards */}
          <div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {features.map((item, index) => (
                <div key={index} className="flex h-full">
                  <div
                    className="relative flex w-full flex-col rounded-[14px] bg-white p-8
        shadow-[0_10px_10px_rgba(13,59,93,0.12)]
        transition-all duration-300
        hover:-translate-y-2
        hover:shadow-[0_16px_40px_rgba(13,59,93,0.18)]"
                  >
                    {item.isNew && (
                      <div className="absolute top-0 right-0 overflow-hidden w-24 h-24 pointer-events-none z-10">
                        <div className="absolute top-4 -right-8 w-32 rotate-45 bg-[#FF0000] text-white text-sm font-bold text-center py-1 shadow-lg uppercase">
                          NEW
                        </div>
                      </div>
                    )}
                    {/* Icon */}
                    <div className="mb-5 flex justify-center">
                      <div
                        className="flex h-16 w-16 items-center justify-center
            rounded-xl bg-white
            shadow-[0_6px_20px_rgba(13,59,93,0.15)]"
                      >
                        {item.icon}
                      </div>
                    </div>

                    {/* Title */}
                    <h2 className="mb-3 text-center text-lg font-semibold text-[#10324F]">
                      {item.title}
                    </h2>

                    {/* Description */}
                    <p className="mb-6 flex-1 text-center text-sm leading-[180%] text-[#10324F]">
                      {item.desc}
                    </p>

                    {/* Button */}
                    <Link
                      onClick={() => {
                        window.location.href = item.link;
                      }}
                      className="mt-1 rounded-md border border-[#D1DFEA]
          bg-[linear-gradient(180deg,rgba(209,223,234,0.052)_50.18%,rgba(209,223,234,0.2)_100%)]
          px-6 py-3 text-center text-[15px] font-medium text-[#10324F]
          shadow-[0_6px_18px_rgba(0,0,0,0.12)]
          transition-all duration-200
          hover:-translate-y-0.5
          hover:shadow-[0_10px_24px_rgba(0,0,0,0.16)]"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
